<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-btn color="primary" to="/session"> View All Sessions </v-btn>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="messages" :search="search">
            <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt | formatdate }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Messages',
  data: () => ({
    search: '',
    headers: [
      { text: 'Customer Input', value: 'input' },
      { text: 'Response', value: 'response' },
      { text: 'Date', value: 'createdAt' }
    ]
  }),
  computed: mapState({
    messages: state => state.botsession.messages
  }),
  mounted () {
    this.$store.dispatch('botsession/getSessionMessages', this.$route.params.id)
  }
}
</script>
